import DatePicker_DatePickerDefaultSkinComponent from '@wix/thunderbolt-elements/src/components/DatePicker/viewer/skinComps/DatePickerDefaultSkin/DatePickerDefaultSkin.skin';
import DatePicker_DatePickerDefaultSkinController from '@wix/thunderbolt-elements/src/components/DatePicker/viewer/DatePicker.controller';


const DatePicker_DatePickerDefaultSkin = {
  component: DatePicker_DatePickerDefaultSkinComponent,
  controller: DatePicker_DatePickerDefaultSkinController
};


export const components = {
  ['DatePicker_DatePickerDefaultSkin']: DatePicker_DatePickerDefaultSkin
};

